import { record } from 'fp-ts';
import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { LocalizedText, lt, useLocalizeProperty } from '@mews/framework';
import { Banner, Link } from '@optimus-web/core';
import { Loader } from '@mews-commander/ui';
import { TextKey, RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { getFilterViewResourceParams } from '../../../utils';
import { useFilterValuesContext } from '../../../FilterValuesContext';
import { useRateGroupOfRate } from './useRateGroupOfRate';

export type RateGroupLimitReachedProps = WithEnterpriseId & WithServiceId;

export const RateGroupLimitReached = ({ enterpriseId, serviceId }: RateGroupLimitReachedProps) => {
    const localizeProperty = useLocalizeProperty();
    const resolveRoute = useResolveRoute();
    const { view, ...filterValues } = useFilterValuesContext();

    const enterpriseIds = [enterpriseId];
    const serviceIds = [serviceId];
    const { rateId } = getFilterViewResourceParams(view);
    const { data, isFetching } = useRateGroupOfRate({ enterpriseIds, serviceIds, rateId });

    if (isFetching) {
        return <Loader />;
    }

    const names =
        data?.rateGroup?.shortNames && !record.isEmpty(data.rateGroup.shortNames)
            ? data.rateGroup.shortNames
            : data?.rateGroup?.names;

    const rateGroupName = localizeProperty(names);

    const newFilterValues = {
        ...filterValues,
        OwnerId: serviceId,
        'view.type': 'rateGroup',
        'view.value': data?.rateGroup?.id || '',
    };

    const url = resolveRoute(RouteName.SellLimits, { query: newFilterValues });

    return (
        <Banner
            primaryText={
                <LocalizedText textKey={TextKey.RateGroupLimitReached} substitutes={{ name: rateGroupName }} />
            }
            secondaryText={
                <Link href={url} variant="basic">
                    {lt('SwitchToRateGroupView')}
                </Link>
            }
            variant="info"
        />
    );
};
